import { HOME_ROUTE } from "shared/config/routes";
import { DisabledElementModal } from "widgets/disabled-element-modal";
import { useModal } from "shared/ui/modal";
import LogoImg from "../assets/FooterLogo.svg";
import styles from "./Footer.module.scss";

export const Footer = () => {
  const {
    isModalOpen: isDisabledElementModalOpen,
    open: openDisabledElementModal,
    close: closeDisabledElementModal,
    toggle: toggleDisabledElementModal,
  } = useModal(false);

  return (
    <>
      <div className={styles.footerContainer}>
        <div className={styles.footerWrapper}>
          <div className={styles.footerWrapper__topBlock}>
            <div className={styles.footerWrapper__logo}>
              <a href={HOME_ROUTE}>
                <img
                  src={LogoImg}
                  className={styles.footerWrapper__logoImg}
                  alt="LogoImg"
                />
              </a>
            </div>
            <div className={styles.footerWrapper__links}>
              <div className={styles.footerWrapper__linksCatalog}>
                <p className={styles.footerWrapper__title}>Каталог</p>
                <a
                  className={styles.footerWrapper__link}
                  onClick={openDisabledElementModal}
                >
                  Препараты
                </a>
                <a
                  className={styles.footerWrapper__link}
                  onClick={openDisabledElementModal}
                >
                  Оборудование
                </a>
              </div>
              <div className={styles.footerWrapper__linksSections}>
                <p className={styles.footerWrapper__title}>Разделы</p>
                <a
                  href={`${HOME_ROUTE}#about`}
                  className={styles.footerWrapper__link}
                >
                  О нас
                </a>
                <a
                  href={`${HOME_ROUTE}#products`}
                  className={styles.footerWrapper__link}
                >
                  Каталог
                </a>
                <a
                  href={`${HOME_ROUTE}#brands`}
                  className={styles.footerWrapper__link}
                >
                  Бренды
                </a>
                <a
                  href={`${HOME_ROUTE}#blog`}
                  className={styles.footerWrapper__link}
                >
                  Новости
                </a>
                <a
                  onClick={openDisabledElementModal}
                  className={styles.footerWrapper__link}
                >
                  Контакты
                </a>
                <a
                  onClick={openDisabledElementModal}
                  className={styles.footerWrapper__link}
                >
                  Сертификаты
                </a>
              </div>
              <div className={styles.footerWrapper__linksMore}>
                <p className={styles.footerWrapper__title}>Дополнительно</p>
                <a
                  className={styles.footerWrapper__link}
                  onClick={openDisabledElementModal}
                >
                  Доставка
                </a>
                <a
                  className={styles.footerWrapper__link}
                  onClick={openDisabledElementModal}
                >
                  Заказы
                </a>
                <a
                  className={styles.footerWrapper__link}
                  onClick={openDisabledElementModal}
                >
                  Платежи
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DisabledElementModal
        isModalOpen={isDisabledElementModalOpen}
        open={openDisabledElementModal}
        close={closeDisabledElementModal}
        toggle={toggleDisabledElementModal}
      />
    </>
  );
};
